import axios from "axios";
import store from "@/store";

const deboters = {
    namespaced: true,
    state: {},
    mutations: {},
    actions: {
        async getDeboters() {
            let response = await axios.get(`/debtors`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getPayDocument() {
            let response = await axios.get(`/get_pay_check_info`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async sendPayLink(context, payload) {
            let response = await axios.post(`/send_custom_pay_link/${store.state.userName}`, payload);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        }
    },
    getters: {}
}

export default deboters;